import { render } from "./OrderAreaListComponent.vue?vue&type=template&id=537ca5c9"
import script from "./OrderAreaListComponent.vue?vue&type=script&lang=js"
export * from "./OrderAreaListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ShippingSetup/OrderArea/OrderAreaListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "537ca5c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('537ca5c9', __exports__)) {
    api.reload('537ca5c9', __exports__)
  }
  
  module.hot.accept("./OrderAreaListComponent.vue?vue&type=template&id=537ca5c9", () => {
    api.rerender('537ca5c9', render)
  })

}


export default __exports__